<img class="dms-image" [src]="imgSource" />
